import * as Sentry from "@sentry/browser";

const release = process.env.SENTRY_RELEASE;

// Query strings carry search terms and campaign slugs, and a click records the
// clicked element's label, which on the dashboard can be a protocol name or the
// member's own name and email.
const withoutQuery = (value) => (typeof value === "string" ? value.split("?")[0] : value);

function scrubEvent(event) {
  if (event.request) {
    event.request.url = withoutQuery(event.request.url);
    delete event.request.query_string;
    if (event.request.headers?.Referer) {
      event.request.headers.Referer = withoutQuery(event.request.headers.Referer);
    }
  }
  event.spans?.forEach((span) => {
    span.description = withoutQuery(span.description);
    if (span.data?.url) span.data.url = withoutQuery(span.data.url);
  });
  return event;
}

if (release) {
  Sentry.init({
    dsn: "https://8c52f1b4c14af3fe12b8d8fd69dde532@o422027.ingest.us.sentry.io/4511435177132032",
    release,
    environment: "production",
    sendDefaultPii: false,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.25,
    tracePropagationTargets: [window.location.origin],
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.category?.startsWith("ui.")) return null;
      if (breadcrumb.data) {
        for (const key of ["url", "from", "to"]) {
          breadcrumb.data[key] = withoutQuery(breadcrumb.data[key]);
        }
      }
      return breadcrumb;
    },
    beforeSend: scrubEvent,
    beforeSendTransaction: scrubEvent,
  });
}

export default Sentry;
